/**
 * Group-order sessions. Talks to the /grouporders group, which is the admin.php
 * "Group Orders" tab moved into Connect. Non-namespaced like every other module.
 */
import { tr } from "@/i18n";

const notifyError = (commit, message) =>
  commit("NOTIFICATION_MESSAGE", { status: -1, title: "Group orders", message });

const form = (obj) => {
  const p = new URLSearchParams();
  Object.keys(obj).forEach((k) => p.append(k, obj[k]));
  return p;
};

const state = () => ({
  rows: [],
  total: 0,
  stores: [],
  loaded: false,
  error: "",
  detail: null, // { header, participants, items, events }
});

const mutations = {
  RESET_GROUPORDERS(s) { Object.assign(s, state()); },
  SET_GO_LIST(s, { rows, total, stores }) { s.rows = rows || []; s.total = total || 0; s.stores = stores || []; s.loaded = true; s.error = ""; },
  SET_GO_ERROR(s, m) { s.error = m; s.loaded = true; },
  SET_GO_DETAIL(s, v) { s.detail = v; },
};

const actions = {
  /** The first load shows the global loader; filter, page and search changes pass silent so the panel stays usable. */
  async getGroupOrders({ commit }, arg) {
    const params = arg && arg.params ? arg.params : arg;
    const silent = !!(arg && arg.silent);
    if (!silent) commit("LOADING", { isActiveStatus: true });
    try {
      const { data } = await window.$http.axios.get("grouporders/list", { params });
      if (data.status) commit("SET_GO_LIST", data);
      else { notifyError(commit, data.message); commit("SET_GO_ERROR", data.message || tr("The server refused the request.")); }
    } catch (e) {
      notifyError(commit, "Could not load group orders.");
      commit("SET_GO_ERROR", tr("Could not reach the group-orders service. It may not be installed on this server yet."));
    } finally {
      if (!silent) commit("LOADING", { isActiveStatus: false });
    }
  },

  async getGroupOrderDetail({ commit }, id) {
    commit("SET_GO_DETAIL", null);
    try {
      const { data } = await window.$http.axios.get("grouporders/detail", { params: { id } });
      if (data.status) commit("SET_GO_DETAIL", { header: data.header, participants: data.participants || [], items: data.items || [], events: data.events || [] });
      else notifyError(commit, data.message);
    } catch (e) {
      notifyError(commit, "Could not load the session.");
    }
  },

  async groupOrderForceClose({ commit }, { id, reason }) {
    try {
      const { data } = await window.$http.axios.post("grouporders/force-close", form({ id, reason }));
      if (data.status) { commit("NOTIFICATION_MESSAGE", { status: 1, title: "Group orders", message: "Session closed for everyone." }); return true; }
      notifyError(commit, data.message); return false;
    } catch (e) { notifyError(commit, "Could not close the session."); return false; }
  },
};

export default { state, mutations, actions };
